// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","sectionHeader":"Section_sectionHeader__SVyg1","actionsWrapper":"Section_actionsWrapper__6s02c"};